import { Suspense } from 'react'
import { LazyLoadWrapper } from '../LazyLoadWrapper'
import { InferFormValues, JsonFormSchemaV2 } from './types'
import { TPageFilter } from '../../AppPage2/types'
import { FormComponent, FormComponentLoading } from '.'

interface LazyFormComponentProps<TSchema extends JsonFormSchemaV2> {
  id: string
  layout?: 'form' | 'headerFilter'
  pinnedFieldId?: string
  filters?: TPageFilter[]
  pinFilter?: (selectedF: TPageFilter, side: 'left' | 'right') => void
  isConfiguringLayout?: boolean
  resetDefaults?: InferFormValues<TSchema>
  closeSheetOnSubmit?: boolean
  className?: string
}

/**
 * A wrapper around FormComponent that only fetches data when the component is visible
 * or about to become visible in the viewport
 */
export function LazyFormComponent<TSchema extends JsonFormSchemaV2>(props: LazyFormComponentProps<TSchema>) {
  return (
    <LazyLoadWrapper
      placeholder={<FormComponentLoading />}
      triggerOffset="300px" // Start loading when within 300px of viewport
      toggleOnVisibility
    >
      <Suspense fallback={<FormComponentLoading />}>
        <FormComponent {...props} />
      </Suspense>
    </LazyLoadWrapper>
  )
}
